import api from '../lib/api'
import assign from 'lodash.assign'
import share from '../types/share.types'
import global from '../types/global.types'
import ShareMaker from '../lib/shareMaker'
import login from '@/utils/login'

const name = 'share'

export default {
  name,
  namespaced: true,
  state: {
    type: 1,
    courseId: '',
    chapterId: '',
    shareMark: '',
    leftChapters: 0, // 打卡天数
    info: {},
    bubbleShow: false,
    encourageType: 0, // 奖励类型
    encourageValue: 0 // 奖励金额
  },
  getters: {},
  mutations: {
    set (state, data) {
      assign(state, data)
    },

    [share.SET_SHARE_TYPE] (state, type) {
      state.type = type
    },

    [share.SET_USER_INFO] (state, info) {
      state.info = info
    },

    [share.SET_COURSE] (state, course) {
      assign(state, course)
    }
  },
  actions: {
    async checkLogin () {
      const wpsSid = await login.getWpsSid()
      return wpsSid || login.login()
    },

    setShareType ({ commit }, type) {
      commit(share.SET_SHARE_TYPE, Number(type))
    },

    async getInfo ({ commit, state, dispatch }, query) {
      try {
        const senderWpsSid = await login.getWpsSid() || ''
        commit(share.SET_COURSE, { senderWpsSid })
        const res = await api.share.info(state.courseId, state.chapterId, state.senderWpsSid, state.userId, state.shareMark)()
        console.log(res)

        res.code === -2 ? dispatch('checkLogin') : commit(share.SET_USER_INFO, res.data)
      } catch (E) {
        // commit(global.ERR, '获取用户信息出错！', { root: true })
      }
    },

    async setCourse ({ commit }, query) {
      const { courseId, chapterId, userId, shareMark } = query
      commit(share.SET_COURSE, { courseId, chapterId, userId, shareMark })
    },

    async setNormalShare ({ commit, state, dispatch }) {
      const _link = state.shareMark === 'signIn' ? location.href : (location.href.includes('&shareMark=signShare') ? location.href.replace('&shareMark=signShare', '&shareMark=signIn') : location.href)
      const _title = state.info.shareContent ? state.info.shareContent : `我正在学习《${state.info.courseName}》,累计打卡${state.info.accumulateDays}天`

      return new ShareMaker({
        title: _title,
        introduction: state.info.courseName,
        link: _link,
        imgUrl: this.$store.state.organizationMessage.organLogo,
        success () {
          setTimeout(() => dispatch('clockIn'), 300)
        }
      }, location.href, true)
    },

    // 打卡
    async clockIn ({ commit, state }) {
      const { courseId, chapterId, senderWpsSid } = state
      const res = await api.clockIn.clockIn({ chapterId, courseId, userId: senderWpsSid })

      try {
        const { encourageType, encourageValue, leftChapters, result } = res.data
        if (result === 1) {
          // commit(global.ERR, '打卡成功', { root: true })
          commit('set', { encourageType, encourageValue, leftChapters, bubbleShow: true })
        } else if (result === 0) {
          commit(global.ERR, `本章节您已打卡,请勿重复打卡`, { root: true })
        } else {
          commit(global.ERR, `${res.code}: ${res.msg}`, { root: true })
        }
      } catch (e) {
        console.log(e)
      }
    },

    async init ({ commit, dispatch, state }) {
      dispatch('getInfo').then(_ => {
        dispatch('setNormalShare')
      })
    }
  }
}
